<template>
  <a-modal v-model="visible" class="batch_dialog" :body-style="{padding:0}" :title="`批量编辑线路（${num}条）`" :after-close="afterClose" @ok="handleOk">
      <a-alert v-if="resonText" :message="`排线失败原因: ${resonText}`" banner />
      <a-form-model
        ref="formRef"
        name="dynamic_form_nest_item"
        :model="form"
        :destroy-on-close="true"
      >
        <a-form-model-item prop="value" :label="item.label" :rules="[{ required: item.required, message: `请输入${item.label}` }]">
          <component
          :is="componentType[item.type]"
          v-if="item.type==='date'"
           v-model="form.value"
          :placeholder="`请输入${item.label}`"
          value-format="YYYY-MM-DD"></component>
          <component
          :is="componentType[item.type]"
           v-else
           v-model="form.value"
          :placeholder="`请输入${item.label}`">
          </component>
        </a-form-model-item>
      </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment'

const componentType={
  input:'a-input',
  date:'a-date-picker'
}
  export default {
    data(){
      return{
        visible:false,
        componentType,
        form:{
          value:''
        },
        num:0,
        resonText:'',
        item:{},
      }
    },
    methods:{
      show(num,item,resonText,valueText){
        this.num=num
        this.item=item
        let value=valueText
        if(item.type==='date'){
          value=value?moment(valueText).format('YYYY-MM-DD'):''
        }
        this.resonText=resonText
        this.$set(this.form,'value',value)
        this.visible=true
      },
     async handleOk() {
        await this.$refs.formRef.validate()
        this.visible = false;
        this.$emit('onchange',this.form.value,this.item.prop)
      },
      afterClose(){
        this.$refs.formRef.clearValidate()
        this.form={}
      },
      
    }
  }
</script>

<style lang="less" scoped>
.ant-calendar-picker{
  width: 100%;
}
.ant-form{
  padding: 24px;
}
</style>